import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/** Legacy booking checkout URL — send users back to the storefront. */
export function BookingCheckoutPage() {
  const { storeUrl } = useParams<{ storeUrl: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (storeUrl) {
      navigate(`/${storeUrl}`, { replace: true });
    }
  }, [navigate, storeUrl]);

  return null;
}
